const DEFAULT_COLORS = {
  primary: { blue: '#0e497b' },
  accent: {
    blue: '#092d4d',
    lightBlue: '#83d3ee',
  }, // example: This is the font color for the values section // TODO: confirm these values after getting Sketch file
  hero: {
    background: '#667785', // TODO: rename/organize these once comp is finalized.
    textStroke: '#2e353a', // TODO: rename/organize these once comp is finalized.
  },
  section: { backgroundBlue: '#0e497b' },
  neutral: {
    white: '#fff',
    grey99: '#f8fafc',
    grey95: '#edf0f3',
    grey59: '#979797',
    grey54: '#8a8a8a',
    grey41: '#696969',
    grey29: '#4a4a4a',
    grey23: '#3a3a3a',
    black: '#000',
  },
  cta: {
    blue: '#1570bc',
    blueHover: '#0e497b',
    blueActive: '#105fcc',
    yellow: '#ffb81c',
    yellowHover: '#cc8b00',
    yellowActive: '#FFB81C',
  },
  system: {
    cautionWarning: '#ffcc33',
    darkBlue: '#004ab3',
    negativeError: '#ff5242',
    darkRed: '#dc100d',
    positiveSuccess: '#00a84f',
    darkGreen: '#00803c',
  },
  pcg: {
    gold1: '#e1c88f',
    gold2: '#f2dfac',
    darkBlue1: '#0F1117',
    darkBlue2: '#0F2160',
  },
  modal: {
    stroke: '#2071AA', // TODO: also duplicate in Sass files // TODO: confirm do we REALLY need to add another color so close to our other cta blue(s)? will confirm with creative.
  },

  // Other
  blueOnBlueHeadingAccess: '#83d4f1', // TODO: rename/organize these once comp is finalized.
  blueLazyloadBg: '#afb9c0', // #667785; // #8597a1;

  // TODO: build in shade and highlight functions
};
export default DEFAULT_COLORS;

export const getColorForName = (color) => {
  // Return the corresponding color, else return hex if a valid hex is provided
  if (color === 'color-neutral-black') return DEFAULT_COLORS.neutral.black;
  if (color === 'color-neutral-white') return DEFAULT_COLORS.neutral.white;
  if (color === 'color-neutral-gray-29') return DEFAULT_COLORS.neutral.grey29;
  if (color === 'color-neutral-gray-23') return DEFAULT_COLORS.neutral.grey23;
  if (color === 'color-primary-nm-blue') return DEFAULT_COLORS.primary.blue;
  if (color === 'color-hero-text-stroke') return DEFAULT_COLORS.hero.textStroke;
  if (color === 'color-system-dark-red') return DEFAULT_COLORS.system.darkRed;
  // if we get here, check for a hex value
  if (/^#([0-9A-F]{3}){1,2}$/i.test(color)) return color;
  // if we get here, an invalid color was passed in, we will return it anyway as to not break the page, but log error
  console.error(`Invalid color provided: ${color}, please use a valid defined color name or hex value.`);
  return color;
};

